import type { ImgHTMLAttributes } from "react";
import { useTheme } from "next-themes";
import { cn } from "../../lib/utils";

type BrandLockupProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "width" | "height">;

const darkWordmarkSource = import.meta.env.DEV
  ? `/brand/io-spoke-wordmark-color-dark.png?updated=${Date.now()}`
  : "/brand/io-spoke-wordmark-color-dark.png";

export function BrandLockup({ alt = "", className, ...props }: BrandLockupProps) {
  const { resolvedTheme } = useTheme();
  const source = resolvedTheme === "dark"
    ? darkWordmarkSource
    : "/brand/io-spoke-wordmark-color.png";

  return (
    <img
      src={source}
      width="1410"
      height="415"
      alt={alt}
      className={cn("shrink-0 object-contain", className)}
      {...props}
    />
  );
}
